import React from "react";
import ConfirmationModal from "./ConfirmationModal.jsx";

export default function DataManagerOrdersConfirmationDialogs({
  clearDeliveredDialog = null,
  createOrderDialog = null,
  deleteSelectionDialog = null,
}) {
  const {
    canBulkDeleteOrders = false,
    isDeletingSelection = false,
    isOpen: isDeleteSelectionDialogOpen = false,
    onClose: onCloseDeleteSelectionDialog,
    onConfirm: onConfirmDeleteSelection,
    selectedCount: selectedDeleteCount = 0,
  } = deleteSelectionDialog || {};
  const {
    isOpen: isCreateOrderDialogOpen = false,
    onClose: onCloseCreateOrderDialog,
    onConfirm: onConfirmCreateOrder,
    summaryItems: createOrderConfirmationSummaryItems = [],
  } = createOrderDialog || {};
  const {
    isOpen: isClearDeliveredDialogOpen = false,
    isPending: isClearDeliveredPending = false,
    onClose: onCloseClearDeliveredDialog,
    onConfirm: onConfirmClearDelivered,
    order: clearDeliveredOrder = null,
  } = clearDeliveredDialog || {};

  return (
    <>
      {isDeleteSelectionDialogOpen ? (
        <ConfirmationModal
          confirmLabel={isDeletingSelection ? "Suppression..." : "Supprimer"}
          description="Cette action supprime définitivement les commandes sélectionnées du Data Manager actif."
          impactItems={[
            "Les lignes sélectionnées seront retirées de la grille active.",
            "Chaque commande sera aussi retirée de son dispatch, et son camion recalculé.",
          ]}
          summaryItems={[
            { label: "Commandes ciblées", value: String(selectedDeleteCount) },
            { label: "Mode", value: canBulkDeleteOrders ? "Admin" : "Standard" },
          ]}
          onCancel={onCloseDeleteSelectionDialog}
          onClose={onCloseDeleteSelectionDialog}
          onConfirm={onConfirmDeleteSelection}
          title={selectedDeleteCount > 1 ? "Supprimer la sélection de commandes ?" : "Supprimer cette commande ?"}
          warningMessage="Les commandes supprimées disparaîtront de la grille courante et devront être réimportées si elles doivent revenir dans la source métier."
        />
      ) : null}

      {isCreateOrderDialogOpen ? (
        <ConfirmationModal
          confirmLabel="Sauvegarder"
          description="Cette action enregistre la commande saisie dans le Data Manager actif."
          eyebrow="Création de commande"
          impactItems={[
            "La commande sera ajoutée à la grille active dès que l'enregistrement sera terminé.",
            "Le dispatch devra être revalidé si cette nouvelle commande impacte la journée en cours.",
          ]}
          summaryDensity="compact"
          summaryItems={createOrderConfirmationSummaryItems}
          onCancel={onCloseCreateOrderDialog}
          onClose={onCloseCreateOrderDialog}
          onConfirm={onConfirmCreateOrder}
          title="Confirmer la sauvegarde de la commande ?"
          tone="accent"
          warningMessage="Vérifiez les informations saisies avant de confirmer l'enregistrement."
        />
      ) : null}

      {isClearDeliveredDialogOpen ? (
        <ConfirmationModal
          confirmLabel={isClearDeliveredPending ? "Retrait..." : "Retirer"}
          description="Cette action remet la commande en état planifiable dans Data Manager et retire les confirmations de chargement et de livraison du planning actif."
          eyebrow="Correction de statut"
          impactItems={[
            "Les tonnages chargé réel et livré réel seront effacés pour cette commande.",
            "Le dispatch devra être revalidé si un planning était déjà chargé.",
          ]}
          summaryItems={[
            { label: "Commande", value: clearDeliveredOrder?.order_id || "—" },
            { label: "Client", value: clearDeliveredOrder?.client_name || "—", span: "fill", nowrap: true },
          ]}
          onCancel={onCloseClearDeliveredDialog}
          onClose={onCloseClearDeliveredDialog}
          onConfirm={onConfirmClearDelivered}
          title="Retirer le statut livré ?"
          warningMessage="À utiliser seulement lorsqu'une commande a été marquée livrée par erreur."
        />
      ) : null}
    </>
  );
}
